import React from "react";
import { MpaStandardButton } from "../mpa-material-ui-widgets/mpa-material-ui-button";

export class MpaButton extends React.Component {
  constructor(props) {
    super(props);
    const { color, value } = props.meta.stack;
    this.state = {
      color,
      label: value.toString()
    };
  }

  componentWillUnmount() {
    const { socket } = this.props;
    socket.off("rx");
  }

  componentDidMount() {
    const { socket, meta } = this.props;
    socket.on(`rx`, data => {
      if (data.name === meta.stack.name || data.stack === meta.stack.name) {
        switch (data.type) {
          case "COLOR":
            this.setState({ color: data.val });
            break;
          case "VALUE":
            if (
              data.val !== undefined &&
              ["number", "string", "boolean"].includes(typeof data.val)
            ) {
              this.setState({ label: data.val.toString() });
            }
            break;
          default:
            break;
        }
      }
    });
  }

  handleClick = () => {
    const { meta, socket } = this.props;
    socket.emit("tx", {
      widget: {
        name: meta.widget.name,
        type: "BUTTON",
        event: "PRESS"
      }
    });
  };

  render() {
    const { meta } = this.props;
    return (
      <MpaStandardButton
        variant="contained"
        key={meta.widget.name}
        assignedcolor={this.state.color}
        onClick={this.handleClick}
      >
        {this.state.label ? this.state.label : ""}
      </MpaStandardButton>
    );
  }
}
